<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Group</span>
          <span v-else>Create a New Group</span>
        </h1>
        <span>
          <router-link :to="{ name: 'groups' }" class="btn btn_black"
            >Back to List</router-link
          >
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div :class="['form_row', { has_error: errorFor('name') }]">
                <label class="required">Group Name</label>
                <div class="form_inline">
                  <input type="text" class="form_global" v-model="group.name" />
                  <v-errors :errors="errorFor('name')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_2 pr_20">
              <div
                :class="['form_row', { has_error: errorFor('sort_number') }]"
              >
                <label class="required">Sort Number</label>
                <div class="form_inline">
                  <input
                    type="number"
                    class="form_global"
                    v-model="group.sort_number"
                  />
                  <v-errors :errors="errorFor('sort_number')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_4 pl_20">
              <div :class="['form_row', { has_error: errorFor('status') }]">
                <label class="required">Status</label>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="statusActive"
                    v-model="group.status"
                    value="1"
                  />
                  <label for="statusActive">Active</label>
                </div>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="statusInactive"
                    v-model="group.status"
                    value="0"
                  />
                  <label for="statusInactive">Inactive</label>
                </div>
                <v-errors :errors="errorFor('status')"></v-errors>
              </div>
            </div>
            <div class="col_12">
              <div
                :class="['form_row', { has_error: errorFor('description') }]"
              >
                <label>Description</label>
                <div class="form_inline">
                  <text-editor
                    v-model:text="group['description']"
                    :id="'group'"
                  ></text-editor>
                  <v-errors :errors="errorFor('description')"></v-errors>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_6">
              <div class="form_row">
                <label></label>
                <div class="form_inline">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                    v-if="$route.params.id"
                  >
                    Update
                  </button>
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                    v-else
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import TextEditor from '@/components/shared/TextEditor';
export default {
  name: 'group-form',
  components: { LoaderMaskComponent, TextEditor },
  data() {
    return {
      lyLoading: false,
      group: {
        name: '',
        status: 1,
        description: '',
        sort_number: '',
      },
    };
  },
  created() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
  },
  methods: {
    loadData(groupId) {
      this.lyLoading = true;
      this.axios
        .get('/groups/' + groupId)
        .then((response) => {
          let groupData = response.data.data;
          this.group.name = groupData.name;
          this.group.sort_number = groupData.sort_number;
          this.group.description = groupData.description;
          this.group.status = groupData.status ? 1 : '0';
        })
        .catch(() => {
          this.showFailMsg('No group exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.group).forEach((key) => {
        formData.append(key, this.group[key] ? this.group[key] : '');
      });

      this.axios
        .post('/groups', formData)
        .then(() => {
          this.resetForm();
          this.showSuccessMsg('Group Created Successfully!');
          this.$router.push({ name: 'groups' });
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.group).forEach((key) => {
        formData.append(key, this.group[key] ? this.group[key] : '');
      });

      this.axios
        .post('/groups/' + this.$route.params.id, formData)
        .then(() => {
          this.showSuccessMsg('Group Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    resetForm() {
      this.group = {
        name: '',
        sort_number: '',
        description: '',
        status: 1,
      };
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
